import { render } from "./upload-image.view.vue?vue&type=template&id=21808f84&scoped=true&ts=true"
import script from "./upload-image.view.vue?vue&type=script&lang=ts"
export * from "./upload-image.view.vue?vue&type=script&lang=ts"

import "./upload-image.view.vue?vue&type=style&index=0&id=21808f84&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21808f84"]])

export default __exports__